concourse-avatar {
  /* --chip-color: var(--ion-color-secondary); */
  --text-color: white;
  --chip-border-size: 1px;
  display: block;
  width: var(--chip-avatar-size);
  height: var(--chip-avatar-size);
  margin: 0;
  padding: 0;
}

concourse-avatar ::slotted([slot='start']) {
  margin-inline-end: 0;
  -webkit-margin-end: 0;
}

.profile-image {
  width: var(--chip-avatar-size);
  height: var(--chip-avatar-size);
  /* position: absolute;
  left: 0; */
}

.profile-icon {
  font-size: calc(var(--chip-avatar-size) / 3);
  color: var(--text-color);
  width: var(--chip-avatar-size);
  height: var(--chip-avatar-size);
}
.profile-image__deleted-person {
  opacity: 0.55;
  filter: grayscale(100%);
}

.profile-logo {
  font-size: calc(var(--chip-avatar-size) / 3);
  border-radius: 50%;
  width: var(--chip-avatar-size);
  height: var(--chip-avatar-size);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  position: relative;
  margin: 0;
  padding: 0;
}

.profile-logo::before {
  content: '';
  position: absolute;
  width: calc(100% - 6px);
  height: calc(100% - 6px);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: var(--chip-color);
  border-radius: 50%;
  z-index: -1;
  margin: 0;
  padding: 0;
}

.concourse-avatar__button:hover {
  cursor: pointer;
}
